import React, { useState, useRef, useEffect } from "react";

const NightsDropdown: React.FC<{ nights: number; handleNightsChange: (value: number) => void }> = ({ nights, handleNightsChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (value: number) => {
    handleNightsChange(value);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        type="button"
        onClick={toggleDropdown}
        className="w-full rounded bg-white md:p-1 focus:outline-none md:px-1 py-2 text-left flex items-center text-[14px]"
        style={{ minWidth: "100px" }} // Set a minimum width for the button
      >
        {nights} {nights === 1 ? "Night" : "Nights"}
        <svg
          className="ml-1 mt-0.5 w-4 h-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="#dc0069"
        >
          <polygon points="12,16 6,8 18,8" />
        </svg>
      </button>
      {isOpen && (
        <ul
          className="absolute z-10 bg-white border border-gray-300 rounded-md shadow-lg w-full max-h-60 overflow-y-auto mt-1 scrollbar-initial"
          style={{ minWidth: "120px" }} // Set a minimum width for the dropdown
        >
          {[...Array(30).keys()].map((day) => (
            <li
              key={day}
              onClick={() => handleOptionClick(day + 1)}
              className={`px-4 py-2 cursor-pointer hover:bg-halo-pink-bg hover:text-halo-pink text-[14px] ${
                nights === day + 1 ? "bg-halo-pink-bg text-halo-pink" : ""
              }`}
            >
              {day + 1} {day === 0 ? "Night" : "Nights"} 
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NightsDropdown;
